export default "__VITE_ASSET__3ed5j1$V__"